export const COUPONTYPE_OFF = 1;
export const INVALIDTYPE = 'invalid';
export const productionFitTypeMap = ['', '所有产品可用', '指定产品可用', '部分类型产品可用'];
